import * as RadioPrimitive from '@radix-ui/react-radio-group';
import classNames from 'clsx';
import { item, root } from './InlineSelect.css';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface InlineSelectProps extends RadioPrimitive.RadioGroupProps {}

export const InlineSelect = (props: InlineSelectProps) => {
  const { className, ...rest } = props;

  return (
    <RadioPrimitive.Root className={classNames(root, className)} {...rest} />
  );
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface InlineSelectItemProps
  extends RadioPrimitive.RadioGroupItemProps {}

export const InlineSelectItem = (props: InlineSelectItemProps) => {
  const { children, className, ...rest } = props;

  return (
    <RadioPrimitive.Item className={classNames(item, className)} {...rest}>
      {children}
    </RadioPrimitive.Item>
  );
};
